// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { SquareTextBoxFragmentDoc } from './SquareTextBox.fragment.generated';
import { SquareImageBoxFragmentDoc } from './SquareImageBox.fragment.generated';
export const SquareBoxesFragmentDoc = gql`
    fragment squareBoxes on SquareBoxes {
  ... on SquareTextBox {
    ...squareTextBox
  }
  ... on SquareImageBox {
    ...squareImageBox
  }
}
    ${SquareTextBoxFragmentDoc}
${SquareImageBoxFragmentDoc}`;